import React from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';

import { toAbsoluteUrl } from 'tradera/utils/url';
import { isNextJs } from 'tradera/utils/nextjs';
import classNames from 'classnames';
import { SITE_LAYOUT } from 'tradera/constants/ui';
import openGraphTraderaImage from 'static/images/logos/open-graph-tradera-default.png';

const BODY_PAGETYPE_CLASS_PREFIX = 'site-pagename-';

const PageHead = (props) => {
    if (isNextJs) {
        return null;
    }

    const {
        breadcrumbs,
        canonicalLink,
        metaDescription,
        metaRobots,
        metaTitle,
        ogImage,
        siteLayout,
        type
    } = props;

    const ogImageHttps = ogImage || openGraphTraderaImage;
    const ogImageHttp = ogImageHttps.replace(/^https:/, 'http:');

    const bodyClass = classNames(
        `${BODY_PAGETYPE_CLASS_PREFIX}${type}`,
        siteLayout === SITE_LAYOUT.FULL_WIDTH && 'site-width-full'
    );

    return (
        <Helmet>
            <title>{metaTitle}</title>
            <meta name="description" content={metaDescription} />
            <meta name="robots" content={metaRobots} />
            <link rel="canonical" href={toAbsoluteUrl(canonicalLink)} />
            <script type="application/ld+json">{breadcrumbs}</script>
            <body className={bodyClass} />
            <meta property="og:url" content={toAbsoluteUrl(canonicalLink)} />
            <meta property="og:title" content={metaTitle} />
            <meta property="og:description" content={metaDescription} />
            <meta property="og:image" content={ogImageHttp} key="og:image" />
            <meta
                property="og:image:secure_url"
                content={ogImageHttps}
                key="og:image:secure_url"
            />
        </Helmet>
    );
};

const mapStateToProps = (state) => {
    return {
        breadcrumbs: state.page.breadcrumbs,
        canonicalLink: state.page.canonicalLink,
        metaDescription: state.page.metaDescription,
        metaRobots: state.page.metaRobots,
        metaTitle: state.page.metaTitle,
        ogImage: state.page.ogImage,
        type: state.page.type,
        siteLayout: state.ui.siteLayout
    };
};

export default connect(mapStateToProps)(PageHead);
